/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit PatientEmail/view.blocks to change it.
import Input from 'DesignSystem/Input/index'
import PreviousQuestion from './PreviousQuestion/index'
import Question from 'DesignSystem/Question/index'
import React from 'react'
import Status from './Status/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function PatientEmail({
  children,
  viewPath = "/App/Form/Data/ProvideData/PatientEmail",
  onChange,
  onSubmit,
  value
  
}) {
  return (<React.Fragment
>
<div
  data-testid="PatientEmail.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="PatientEmail.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<PreviousQuestion
  viewPath={`${viewPath}/PreviousQuestion`}
/>
<Question
  viewPath={`${viewPath}/Question`}
 marginTop={4}
 marginBottom={0}
 text="What is the patient's email address?"
/>
</div>
<Input
  viewPath={`${viewPath}/Input`}
 autoFocus={true}
 onChange={onChange}
 onSubmit={onSubmit}
 placeholder="i.e. name@email.com"
 textTransform="none"
 type="email"
 value={value}
/>
<Status
  viewPath={`${viewPath}/Status`}
 onSubmit={onSubmit}
/>
</div>
{children}
</React.Fragment>)
}